import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=f3e9219a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3e9219a')) {
      api.createRecord('f3e9219a', component.options)
    } else {
      api.reload('f3e9219a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=f3e9219a&", function () {
      api.rerender('f3e9219a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29ZFcY97A4d0y/JS/cancellationPolicy.vue"
export default component.exports